import { type UseQueryResult, useQuery } from 'react-query';
import { TableParams } from '../../types/common';
import {
  ParticipantCashTransferServiceService,
  Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_CashTransferExportDto_Wealthlane_AwardSettlementService_Application_Contracts,
} from '../../services/wealthlane-award-settlement-services';

const useGetCashTransfer = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParams
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_CashTransferExportDto_Wealthlane_AwardSettlementService_Application_Contracts
  | undefined,
  unknown
> => {
  const {
    filter,
    sorting,
    skipCount,
    maxResultCount,
    cashTransferStatusIds,
    transferTypeIds,
    cancelStatusIds,
    requestDate,
    companyIds,
  } = tableInfo;

  const getCashTransfer = useQuery(
    [
      'getCashTransfer',
      cashTransferStatusIds,
      transferTypeIds,
      cancelStatusIds,
      requestDate,
      companyIds,
      filter,
      sorting,
      skipCount,
      maxResultCount,
    ],
    async () => {
      return await handleRequest(
        ParticipantCashTransferServiceService.getApiAwardSettlementApiAppParticipantCashTransferServiceCashTransfer(
          [cashTransferStatusIds],
          [transferTypeIds],
          [cancelStatusIds],
          requestDate,
          companyIds,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return getCashTransfer;
};

export default useGetCashTransfer;
